import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect } from 'redux-saga/effects';

import { fetchAdminSites, fetchAdminSitesSuccess, fetchAdminSitesError } from './index';
import { apiInstance } from 'src/services/interceptor';

function* getAdminSites(): SagaIterator {
  try {
    const response = yield call(apiInstance, `admin/sites`);
    yield put(fetchAdminSitesSuccess(response.data));
  } catch (e) {
    yield put(fetchAdminSitesError());
  }
}

function* adminSitesSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchAdminSites.type, getAdminSites);
}

export { adminSitesSaga };
